export const api = {
  wp: {
    url: '/wp-json/playmotivcloud/core/v4',
    adminurl: '/wp-json/playmotivcloud/admin',
    toolsurl: '/wp-json/playmotivcloud/tools/v4',
    awsurl: '/wp-json/playmotivcloud/core/v4/aws?path=',
    options: {
      headers: {          
        'Authorization': 'Bearer ' + window.playmotiv.user.token
      }
    }
  }
}